import { supportedFonts as BettyCrockerFonts } from './brand.BettyCrocker';
import { supportedFonts as BTFEFonts } from './brand.BTFE';
import { supportedFonts as PillsburyFonts } from './brand.Pillsbury';
import { supportedFonts as GeneralMillsFonts } from './brand.GeneralMills';
import { supportedFonts as WhiteLabelFonts } from './brand.WhiteLabel';
import { supportedFonts as GMFSFonts } from './brand.GMFS';
import { supportedFonts as HDFonts } from './brand.HD';
import { supportedFonts as OEPFonts } from './brand.OEP';
import { supportedFonts as CheeriosFonts } from './brand.Cheerios';
import { supportedFonts as AnniesFonts } from './brand.Annies';
import { supportedFonts as CTCFonts } from './brand.CTC';
import { supportedFonts as BlueFonts } from './brand.BLUE';
import { supportedFonts as NatureValleyFonts } from './brand.NatureValley';
import { supportedFonts as LuckyCharmsFonts } from './brand.LuckyCharms';

export const supportedFonts = [
  ...new Set([
    ...BettyCrockerFonts,
    ...BTFEFonts,
    ...PillsburyFonts,
    ...GeneralMillsFonts,
    ...WhiteLabelFonts,
    ...GMFSFonts,
    ...HDFonts,
    ...OEPFonts,
    ...CheeriosFonts,
    ...AnniesFonts,
    ...CTCFonts,
    ...BlueFonts,
    ...NatureValleyFonts,
    ...LuckyCharmsFonts,
  ]),
];
